import { triggerDownload } from "@/Utils/triggerDownload";

export const useDownloadExport = () => {
	const download = (uuid: string) =>
		triggerDownload(`/api/exports/${uuid}/download`);

	return { download };
};